import {
  CLEAR_FILTER,
  SET_CAT_FILTER,
  SET_FILTER,
  SET_LEVEL_FILTER,
  SET_LOCATION_FILTER,
  SET_SALARY_FILTER,
  SET_TOOLS,
  SET_TEXT_FILTER,
} from "../constants";

const filterDefaultState = {
  text: "",
  filter: "",
  category: "",
  location: "",
  level: "",
  salary: "",
  tools: "",
};

const filterReducer = (state = filterDefaultState, action) => {
  switch (action.type) {
    case SET_FILTER:
      //   if (state.filter.includes(action.filter)) {
      //     return {
      //       ...state,
      //       filter: state.filter.filter((item) => item !== action.filter),
      //     };
      //   }
      //   return {
      //     ...state,
      //     filter: [...state.filter, action.filter],
      //   };
      return {
        ...state,
        filter: action.filter,
      };
    case SET_TEXT_FILTER:
      return {
        ...state,
        text: action.text,
      };
    case SET_CAT_FILTER:
      return {
        ...state,
        category: action.category,
      };
    case SET_LOCATION_FILTER:
      return {
        ...state,
        location: action.location,
      };
    case SET_LEVEL_FILTER:
      return {
        ...state,
        level: action.level,
      };
    case SET_TOOLS:
      return {
        ...state,
        tools: action.tools,
      };
    case SET_SALARY_FILTER:
      return {
        ...state,
        salary: action.salary,
      };
    case CLEAR_FILTER:
      return {
        text: "",
        filter: "",
        category: "",
        location: "",
        level: "",
        salary: "",
      };
    default:
      return state;
  }
};

export default filterReducer;
